import * as Yup from "yup"

export const engagementFormSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@.]+$/, "Invalid email format"),
  phone: Yup.string()
    .required("Phone is required")
    .test("phone", "Phone must be a valid 10-digit number", val => {
      if (!val) return false
      return val.replace(/\D/g, "").length === 10
    }),
  loid: Yup.string().required("Loan officer is required"),
  credit_score: Yup.number()
    .required("Credit score is required")
    .min(0, "Credit score must be between 0 and 850")
    .max(850, "Credit score must be between 0 and 850"),
  loan_amount: Yup.string().required("Loan amount is required"),
  custom_fee_amount: Yup.number()
    .nullable()
    .transform((value, original) =>
      original === "" || original === undefined ? null : value
    )
    .min(0, "Must be $0 or more")
    .max(10000, "Cannot exceed $10,000"),
  nonqm_program: Yup.string().when("loan_type", {
    is: "nonqm",
    then: schema => schema.required("Non-QM Program is required"),
    otherwise: schema => schema.optional()
  })
})
